import { root } from './playlists';

export const playlists = {
  ...root,
};
